// hooks
import {
  useCommonInfiniteQueryWithScroll,
  useCommonQuery,
  type UseCommonInfiniteQueryWithScrollOptionsType
} from 'hooks';

// mopdules
import type { BaseApiResponse, BaseSearchRequest, CommonQueryOptions, ResultError } from 'modules';
import type { INation, ReqNations, useGetNationListInfiniteResult } from '../models/nation.model';

// apis
import { NationAPI } from '../apis/nation.api';

// keys
import { nationKeys } from '../keys/nation.key';

export const nationAPI = new NationAPI();

/** 업체 이름 조회 쿼리 훅 - 무한스크롤 */
export const useGetNationListInfinite = ({
  data,
  options
}: {
  data: ReqNations;
  options?: UseCommonInfiniteQueryWithScrollOptionsType<
    BaseApiResponse<unknown, INation>,
    ResultError
  >;
}): useGetNationListInfiniteResult => {
  const queryKeyFactory = (data: ReqNations) => nationKeys.GET_NATION_LIST(data);

  const queryFn = async (data: ReqNations, { page, size }: { page: number; size: number }) => {
    return await nationAPI.getNationList({ ...data, page, size });
  };

  return useCommonInfiniteQueryWithScroll({
    data,
    options,
    queryKeyFactory,
    queryFn
  });
};

export const useGetNationList = ({
  data,
  options
}: {
  data: ReqNations;
  options?: CommonQueryOptions<BaseApiResponse<unknown, INation>, ResultError, INation[]>;
}) => {
  const queryKeyFactory = (data: BaseSearchRequest) => nationKeys.GET_NATION_LIST(data);

  const queryFn = async (data: ReqNations) => {
    return await nationAPI.getNationList(data);
  };

  return useCommonQuery<ReqNations, BaseApiResponse<unknown, INation>, ResultError, INation[]>({
    data,
    options: {
      ...options,
      select: (data) => data.resultList
    },
    queryKeyFactory,
    queryFn
  });
};
